import { createReducer, on } from '@ngrx/store';
import type { Action } from '@ngrx/store';
import { QuestionnaireStep, type State } from '@retention/shared';

import {
  clearQuestionnaireState,
  exitQuestionnaireFlow,
  setActiveStep,
  startQuestionnaire,
} from './questionnaire.action';

export const questionnaireInitialState: State = {
  activeStep: QuestionnaireStep.Start,
};

export const retentionQuestionnaireReducer = createReducer(
  questionnaireInitialState,
  on(startQuestionnaire, (state) => ({
    ...state,
    activeStep: QuestionnaireStep.Start,
    questionnaireResults: undefined,
  })),
  on(setActiveStep, (state, { step }) => ({
    ...state,
    activeStep: step,
  })),
  on(
    exitQuestionnaireFlow,
    (
      state,
      { variable, fixed1Year, fixed3Years, dynamic, highestMatch, answers }
    ) => ({
      ...state,
      questionnaireResults: {
        variable,
        fixed1Year,
        fixed3Years,
        dynamic,
        highestMatch,
        answers,
      },
    })
  ),
  on(clearQuestionnaireState, (state) => ({
    ...state,
    activeStep: QuestionnaireStep.Start,
  }))
);

export function retentionReducer(state: State | undefined, action: Action) {
  return retentionQuestionnaireReducer(state, action);
}
